import { IconButton, Tooltip, Box } from '@mui/material'
import React, { useCallback, useState } from 'react'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { ConfirmationDialog, useModalContext } from '../../../../ui'
import { useIntl } from 'react-intl'
import { usePublicOfferCalls } from '../../hooks'
import feedback from '../../../../core/feedback'
import { useLocation } from 'react-router-dom'
import { usePublicOfferContext } from '../../contexts'
import { parse } from 'qs'
import { DEFAULT_QUERY } from '../table/public-offer-table.constants'

export const TableActions = (props) => {
  const { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useModalContext()
  const location = useLocation()

  const { getTableData } = usePublicOfferContext()

  const { deletePublicOffer } = usePublicOfferCalls()

  const [loading, setLoading] = useState(false)

  const refreshTable = () => {
    const searchString = location.search.split('?')[1]
    if (searchString) {
      const urlSearchParams = parse(searchString)
      const searchParams = {
        ...DEFAULT_QUERY,
        ...urlSearchParams,
      }
      getTableData(searchParams)
    }
  }

  const deleteAction = async () => {
    if (!props.rowData || !props.rowData.id) {
      setLoading(false)
      return
    }

    await deletePublicOffer(props.rowData.id, {}).then((response) => {
      setLoading(false)
      feedback('success', formatMessage({ id: 'pages.campaigns.delete.success' }))
      refreshTable()
    })
  }

  const handleDelete = useCallback(
    (event) => {
      event.stopPropagation()
      setLoading(true)
      open({
        Component: ConfirmationDialog,
        data: {
          title: formatMessage({ id: 'pages.campaigns.delete.modal.title' }),
          text: formatMessage({ id: 'pages.campaigns.delete.modal.text' }),
          yesText: formatMessage({ id: 'pages.campaigns.delete.modal.yes' }),
          noText: formatMessage({ id: 'pages.campaigns.delete.modal.no' }),
          yesAction: deleteAction,
          noAction: () => setLoading(false),
          yesColor: '#00955E',
        },
      })
    },
    [props] // eslint-disable-line react-hooks/exhaustive-deps
  )
  if (!props.rowData) {
    return null
  }

  const columnStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  const actionButtonStyles = {
    border: '1px solid #333',
    borderRadius: '50%',
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
    },
  }

  const actionButtonDisabledStyles = {
    border: '1px solid #ccc',
    borderRadius: '50%',
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
      color: '#ccc',
    },
  }

  if (props.rowData.is_removable)
    return (
      <Box sx={columnStyles}>
        <IconButton sx={actionButtonStyles} size="small" onClick={handleDelete}>
          <DeleteOutlineIcon />
        </IconButton>
      </Box>
    )
  else
    return (
      <Box sx={columnStyles}>
        <Tooltip
          title={formatMessage({ id: 'pages.public.offer.columns.actions.delete.disabled' })}
        >
          <div>
            <IconButton sx={actionButtonDisabledStyles} size="small" disabled>
              <DeleteOutlineIcon />
            </IconButton>
          </div>
        </Tooltip>
      </Box>
    )
}
